import styled from 'styled-components'

const PinContainer = styled.div`
  position: relative;
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const Pin = styled.div`
  z-index: 1;
`

const Svg = styled.svg`
  width: 120px;
  height: 120px;
`

const CircleBackground = styled.circle`
  stroke: transparent;
  stroke-width: 10;
  fill: none;
`

const CircleProgress = styled.circle`
  stroke: white;
  stroke-width: 8;
  fill: none;
  stroke-linecap: round;
  stroke-dasharray: ${({ circumference }) => circumference};
  stroke-dashoffset: ${({ circumference, percentage }) =>
    circumference - (circumference * percentage) / 100};
  transition: stroke-dashoffset 0.5s ease;
  transform: rotate(-90deg);
  transform-origin: center;
`

const DotsContainer = styled.g`
  fill: white;
`

export {
  PinContainer,
  Pin,
  CircleBackground,
  CircleProgress,
  DotsContainer,
  Svg
}
